import React, { useState, useEffect } from "react";
import Login from "./Login";
import PhoneIcon from "@mui/icons-material/Phone";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import {
  Hub,
  NetworkCheck,
  Share,
  SyncAlt,
  CloudSync,
  Help,
} from "@mui/icons-material";
import SupportStaff from "./SupportStaff";
import REB_Logo from "../../assets/REB_Logo.png";
import RTB_Logo from "../../assets/RTB_Logo.png";
import tmis_hero from "../../assets/tmis_hero.jpeg";
import BarChartIcon from "@mui/icons-material/BarChart";
import AssessmentIcon from "@mui/icons-material/Assessment";
import DashboardIcon from "@mui/icons-material/Dashboard";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import ChildFriendlyIcon from "@mui/icons-material/ChildFriendly";
import SchoolIcon from "@mui/icons-material/School";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import { Link } from "react-router-dom/cjs/react-router-dom";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import SearchIcon from "@mui/icons-material/Search";
import SmartphoneIcon from "@mui/icons-material/Smartphone";
import PasswordStrengthBar from "react-password-strength-bar";
import CloseIcon from "@mui/icons-material/Close";

import {
  Alert,
  AlertTitle,
  Autocomplete,
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Checkbox,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  IconButton,
  InputAdornment,
  InputLabel,
  Menu,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";

import { useRef } from "react";
import { showError, showSuccess } from "../../toastify";
import { connect } from "react-redux";

import LoopIcon from "@mui/icons-material/Loop";

import { getPrograms, getOrganizationTypes } from "../../../store/cpd/actions";
import axios from "axios";

import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import ConfirmationDialog from "../../inner/common/components/ConfirmationDialog";
import { useHistory } from "react-router-dom";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const TrainingProviderHome = (props) => {
  const { getPrograms, programs, getOrganizationTypes, organizationTypes } =
    props;

  useEffect(() => {
    getOrganizationTypes();
    getPrograms();
    getAttachmentTypes();
  }, []);

  const [showLoginDialog, setShowLoginDialog] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [showSupportStaffDialog, setShowSupportStaffDialog] = useState(false);
  const [cpdAttachmentTypes, setCpdAttachmentTypes] = useState([]);

  const targetRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 15) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const getAttachmentTypes = async () => {
    try {
      const { data } = await axios.get(`/api/cpd/attachment-types`);
      setCpdAttachmentTypes(data.filter((item) => item.isActive === true));
    } catch (error) {}
  };

  return (
    <React.Fragment>
      <div>
        <link
          href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css"
          rel="stylesheet"
          integrity="sha384-9ndCyUaIbzAi2FUVXJi0CjmCapSmO7SnpJef0486qhLnuZ2cdeRhO02iuK6FUUVM"
          crossOrigin="anonymous"
        />
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/icon?family=Material+Icons"
        />
        <header
          className={` fixed-top transition ${
            isScrolled ? "bg-white elevated-2 py-2" : "bg-transparent py-3"
          }`}
          style={{ transition: "all 0.3s ease" }}
        >
          <div className="container d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center gap-2 logo">
              <Link to="/">
                <img
                  src={REB_Logo}
                  alt="REB Logo"
                  style={{
                    height: "75px",
                    width: "auto",
                    filter: !isScrolled
                      ? "brightness(200%)"
                      : "brightness(100%)",
                  }}
                />
                <img
                  className="ml-2"
                  src={RTB_Logo}
                  alt="RTB Logo"
                  style={{
                    height: "70px",
                    width: "auto",
                    filter: !isScrolled
                      ? "brightness(200%)"
                      : "brightness(100%)",
                  }}
                />
              </Link>
            </div>

            {/* <Link
              to="/"
              style={{
                // background: "linear-gradient(to right, #e76f51, #fd7e14)",

                background:
                  "linear-gradient(to right, rgb(81 231 215), rgb(253, 126, 20))",
                color: "white",
                padding: "0.75rem 2rem",
                borderRadius: "50px",
                fontWeight: 600,
                fontSize: "1.1rem",
                boxShadow: "0 8px 32px rgba(253,126,20,0.12)",
                transition: "all 0.3s",
                textDecoration: "none",
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = "scale(1.05)";
                e.currentTarget.querySelector(".arrow").style.transform =
                  "translateX(4px)";
              }}
              
              onMouseOut={(e) => {
                e.currentTarget.style.transform = "";
                e.currentTarget.querySelector(".arrow").style.transform = "";
              }}
            >
              <span className="d-flex align-items-center gap-2">
                <WorkspacePremiumIcon
                  style={{ fontSize: "18px" }}
                  // className="mr-2"
                />
                TRAINING PROVIDER
              </span>
            </Link> */}
          </div>
        </header>

        {/* <section
          className="position-relative"
          style={{
            paddingTop: "8rem",
            backgroundColor: "#001d40",
            overflow: "hidden",
            minHeight: "580px",
          }}
        >
          <div className="position-absolute" style={{ inset: 0, zIndex: 0 }}>
            <div
              className="position-absolute"
              style={{
                top: "80px",
                right: "80px",
                width: "320px",
                height: "320px",
                background: "#fd7e14",
                borderRadius: "50%",
                mixBlendMode: "multiply",
                filter: "blur(120px)",
                opacity: "0.18",
                animation: "blob 7s infinite",
              }}
            ></div>
            <div
              className="position-absolute"
              style={{
                bottom: "80px",
                left: "80px",
                width: "320px",
                height: "320px",
                background: "#0d6efd",
                borderRadius: "50%",
                mixBlendMode: "multiply",
                filter: "blur(120px)",
                opacity: "0.18",
                animation: "blob 7s infinite 2s",
              }}
            ></div>
          </div>

          <div className="container position-relative" style={{ zIndex: 1 }}>
            <div className="row align-items-center">
              <div className="col-lg-8 mb-5 mb-lg-0 text-center text-lg-start">
                <h1
                  className="display-3 fw-bold mb-3"
                  style={{
                    background:
                      "linear-gradient(90deg, #fd7e14 30%, #e76f51 100%)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    letterSpacing: "1px",
                    lineHeight: 1.5,
                  }}
                >
                  Training Provider's Portal
                </h1>
                <h2
                  className="h4 fw-bold text-white mb-3"
                  style={{ letterSpacing: ".5px" }}
                >
                  Teacher Management Information System
                </h2>
                <p
                  className="fs-5 text-white-50 mb-4"
                  style={{ maxWidth: 540, margin: "0 auto 2rem 0" }}
                >
                  Rwanda’s trusted platform for efficient teacher management
                  centralizing recruitment, deployment, and career support to
                  strengthen education nationwide.
                </p>

                <div className="d-flex align-items-center gap-3">
                  <div
                    className="d-flex align-items-center gap-2 btn btn-primary rounded-pill px-4 py-2 shadow"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      if (targetRef?.current) {
                        targetRef.current.scrollIntoView({
                          behavior: "smooth",
                          block: "start",
                        });
                      }
                    }}
                  >
                    <GroupAddIcon style={{ fontSize: "18px" }} />
                    <span className="fw-medium">MEMBERSHIP APPLICATION</span>
                  </div>
                  <div
                    className="d-flex align-items-center gap-2 btn rounded-pill px-4 py-2 shadow"
                    style={{
                      cursor: "pointer",

                      background: "linear-gradient(to right, #e76f51, #fd7e14)",

                      color: "white",
                      padding: "0.75rem 2rem",
                      borderRadius: "50px",
                      fontWeight: 600,
                      fontSize: "1.1rem",
                      boxShadow: "0 8px 32px rgba(253,126,20,0.12)",
                      transition: "all 0.3s",
                    }}
                    onClick={() => {}}
                  >
                    <SearchIcon style={{ fontSize: "18px" }} />
                    <span className="fw-medium"> TRACK YOUR APPLICATION</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section> */}

        <div
          className="pt-5"
          id="membership-request"
          ref={targetRef}
          style={{ background: "#001d40" }}
        >
          <section>
            <MembershipRequestForm
              programs={programs}
              organizationTypes={organizationTypes}
              cpdAttachmentTypes={cpdAttachmentTypes}
            />
          </section>
        </div>

        {/* <footer
          style={{
            background: "#fff",
            color: "#001d40",
            paddingTop: "2.5rem",
            paddingBottom: "1.5rem",
            marginTop: "3rem",
            boxShadow: "0 -10px 20px -5px rgba(0,0,0,0.04)",
          }}
        >
          <div className="container">
            <div className="row align-items-center mb-4">
              <div className="col-md-4 text-center text-md-start mb-3 mb-md-0 d-flex align-items-center justify-content-center justify-content-md-start gap-3">
                <img
                  src={REB_Logo}
                  alt="REB Logo"
                  style={{
                    height: "70px",
                    width: "auto",
                    filter: "brightness(1)",
                  }}
                />
                <img
                  src={RTB_Logo}
                  alt="RTB Logo"
                  style={{
                    height: "70px",
                    width: "auto",
                    filter: "brightness(1)",
                  }}
                />
              </div>
              <div className="col-md-4 text-center mb-3 mb-md-0">
                <p
                  className="mb-0"
                  style={{ fontSize: "1.05rem", color: "#001d40" }}
                >
                  <span style={{ color: "#fd7e14", fontWeight: 600 }}>
                    TMIS
                  </span>{" "}
                  – Empowering Rwanda’s education through smart teacher
                  management.
                </p>
              </div>
              <div className="col-md-4 text-center text-md-end">
                <span
                  className="text-decoration-none me-3"
                  style={{
                    color: "#fd7e14",
                    fontWeight: 500,
                    cursor: "pointer",
                    transition: "color 0.2s",
                  }}
                  onClick={() => setShowSupportStaffDialog(true)}
                  onMouseOver={(e) => (e.currentTarget.style.color = "#e76f51")}
                  onMouseOut={(e) => (e.currentTarget.style.color = "#fd7e14")}
                >
                  Support
                </span>
              </div>
            </div>
            <hr style={{ borderColor: "rgba(0,0,0,0.08)" }} />
            <div className="row">
              <div className="col-12 text-center">
                <small style={{ color: "#001d40" }}>
                  &copy; {new Date().getFullYear()} All rights reserved.
                </small>
              </div>
            </div>
          </div>
        </footer> */}

        {/* <style jsx global>{`
          @keyframes blob {
            0% {
              transform: scale(1);
            }
            33% {
              transform: scale(1.1);
            }
            66% {
              transform: scale(0.9);
            }
            100% {
              transform: scale(1);
            }
          }
          @keyframes pulse {
            0% {
              opacity: 0.7;
            }
            50% {
              opacity: 0.4;
            }
            100% {
              opacity: 0.7;
            }
          }
          .hover-shadow:hover {
            box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
          }
        `}</style> */}
      </div>
      {/* {showLoginDialog && (
        <Login
          showLoginDialog={showLoginDialog}
          setShowLoginDialog={setShowLoginDialog}
        />
      )} */}
      {/* {showSupportStaffDialog && (
        <SupportStaff
          showSupportStaffDialog={showSupportStaffDialog}
          setShowSupportStaffDialog={setShowSupportStaffDialog}
        />
      )} */}
    </React.Fragment>
  );
};

const mapStateToProps = ({ user, loading, programs, organizationTypes }) => {
  return { user, loading, programs, organizationTypes };
};
export default connect(mapStateToProps, { getPrograms, getOrganizationTypes })(
  TrainingProviderHome,
);

const DocumentItem = (props) => {
  const {
    document,
    providerAttachments,
    setproviderAttachments,
    setShowUploadedDocument,
    setUploadedDocument,
    handleUploadedPDFFile,
    disabled,
    error,
    // getDocumentDescription,
  } = props;

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
    event.stopPropagation();
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <div className="col-12">
        <fieldset className={`form-groupborder `}>
          <legend
            className={`w-auto px-2 d-flex align-items-center ${
              error ? "text-danger" : ""
            } `}
            style={{
              fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
              fontWeight: 400,
              fontSize: "0.82rem",
              lineHeight: "1em",
              letterSpacing: "0.00938em",
              color: `rgba(0, 0, 0, 0.6)`,
            }}
          >
            {document.id}.{" "}
            <span className="ml-1">
              {document.name}{" "}
              {!document.isRequired && (
                <span className="ml-1 text-danger">(Optional)</span>
              )}
            </span>
            {/* <Tooltip
              title={document.name}
              placement="top"
              arrow
              enterDelay={200}
              leaveDelay={200}
              componentsProps={{
                tooltip: {
                  sx: {
                    bgcolor: "rgba(33, 33, 33, 0.95)",
                    color: "white",
                    fontSize: "0.875rem",
                    fontWeight: 400,
                    lineHeight: 1.4,
                    padding: "12px 16px",
                    borderRadius: "8px",
                    maxWidth: "320px",
                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                    border: "1px solid rgba(255, 255, 255, 0.1)",
                    backdropFilter: "blur(8px)",
                    "& .MuiTooltip-arrow": {
                      color: "rgba(33, 33, 33, 0.95)",
                    },
                  },
                },
              }}
            >
              <Help
                fontSize="small"
                style={{
                  marginLeft: "6px",
                  marginBottom: "2px",
                  color: "grey",
                  cursor: "pointer",
                  transition: "all 0.2s ease-in-out",
                }}
              />
            </Tooltip> */}
          </legend>
          <div className="form-group1 mb-3">
            <div className="input-group">
              <div className="input-group-prepend">
                <span className="input-group-text">
                  <i className="fas fa-paperclip"></i>
                </span>
              </div>
              {providerAttachments.find(
                (doc) => document.id === doc.id && !!doc.filename,
              ) ? (
                <div
                  className="form-control"
                  style={{
                    backgroundColor: "rgb(229, 246, 253)",
                    color: "#007bff",
                  }}
                >
                  <span
                    className="d-inline-block text-truncate"
                    style={{ cursor: "pointer", maxWidth: "90%" }}
                    onClick={() => {
                      if (!disabled) {
                        setShowUploadedDocument(true);
                        setUploadedDocument({
                          name: document.name,
                          url: providerAttachments.find(
                            (doc) => document.id === doc.id && !!doc.filename,
                          ).url,
                        });
                      }
                    }}
                  >
                    {
                      providerAttachments.find(
                        (doc) => document.id === doc.id && !!doc.filename,
                      ).filename
                    }
                  </span>

                  <IconButton
                    disabled={disabled}
                    size="small"
                    // onClick={handleOpenMenu}
                    onClick={(e) => {
                      handleCloseMenu();

                      const tmpDocuments = [...providerAttachments];

                      const index = tmpDocuments.findIndex(
                        ({ id }) => id === document.id,
                      );

                      if (index >= 0) tmpDocuments.splice(index, 1);

                      setproviderAttachments(tmpDocuments);
                    }}
                    style={{
                      marginTop: "-5px",
                      marginRight: "-10px",
                    }}
                    color="error"
                    className="float-right"
                    aria-label="view"
                  >
                    {/* <MoreHorizIcon /> */}
                    <span className="material-icons mr-1">delete_forever</span>
                  </IconButton>

                  {/* <Menu
                    anchorEl={anchorEl}
                    id="account-menu"
                    open={open}
                    onClose={(e) => {
                      handleCloseMenu();
                      e.stopPropagation();
                    }}
                    PaperProps={{
                      elevation: 0,
                      sx: {
                        overflow: "visible",
                        filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                        mt: 1.5,
                        "& .MuiAvatar-root": {
                          width: 32,
                          height: 32,
                          ml: -0.5,
                          mr: 2,
                        },
                        "&:before": {
                          content: '""',
                          display: "block",
                          position: "absolute",
                          top: 0,
                          right: 15,
                          width: 10,
                          height: 10,
                          bgcolor: "background.paper",
                          transform: "translateY(-50%) rotate(45deg)",
                          zIndex: 0,
                        },
                      },
                    }}
                    transformOrigin={{
                      horizontal: "right",
                      vertical: "top",
                    }}
                    anchorOrigin={{
                      horizontal: "right",
                      vertical: "bottom",
                    }}
                  >
                    <span>
                      <MenuItem
                        onClick={(e) => {
                          handleCloseMenu();
                          setUploadedDocument({
                            name: document.name,
                            url: providerAttachments.find(
                              (doc) => document.id === doc.id && !!doc.filename
                            ).url,
                          });

                          setShowUploadedDocument(true);
                        }}
                        className="text-primary font-weight-bolder"
                      >
                        <span className="material-icons  mr-1">
                          open_in_new
                        </span>
                        Open
                      </MenuItem>
                    </span>

                    <span>
                      <MenuItem
                        onClick={(e) => {
                          handleCloseMenu();

                          const tmpDocuments = [...providerAttachments];

                          const index = tmpDocuments.findIndex(
                            ({ id }) => id === document.id
                          );

                          if (index >= 0) tmpDocuments.splice(index, 1);

                          setproviderAttachments(tmpDocuments);
                        }}
                        className="text-danger"
                      >
                        <span className="material-icons mr-1">
                          remove_circle_outline
                        </span>
                        Remove
                      </MenuItem>
                    </span>
                  </Menu> */}
                </div>
              ) : (
                <>
                  <input
                    disabled={disabled}
                    type="file"
                    name="file"
                    style={{
                      padding: 0,
                      paddingLeft: "3px",
                      paddingTop: "3px",
                      paddingBottom: "3px",
                    }}
                    className={`form-control ${error ? "text-danger" : ""}`}
                    accept="application/pdf"
                    placeholder="Select pdf file"
                    onChange={(e) => handleUploadedPDFFile(e, document)}
                  />
                </>
              )}
            </div>
          </div>
        </fieldset>
      </div>
    </>
  );
};

const MembershipRequestForm = (props) => {
  const { programs, organizationTypes, cpdAttachmentTypes } = props;

  const [providerAttachments, setproviderAttachments] = useState([]);
  const [showUploadedDocument, setShowUploadedDocument] = useState(false);
  const [uploadedDocument, setUploadedDocument] = useState(null);

  const convertToLower = (value) => {
    return value.toLowerCase();
  };

  const isFileTooLarge = (file) => {
    const size = file.size;
    return size > 3222528 ? true : false;
  };

  const handleUploadedPDFFile = (event, document) => {
    let pdfAttachment = event.target.files[0];

    if (convertToLower(pdfAttachment?.name?.substr(-4)) !== ".pdf") {
      showError("File should be pdf format");
    } else if (isFileTooLarge(pdfAttachment)) {
      showError("Allowed file should not exceed 3MB");
    } else {
      const index = providerAttachments.findIndex(
        ({ id }) => id === document.id,
      );
      const attachments = [...providerAttachments];
      document.file = pdfAttachment;
      document.filename = pdfAttachment.name;

      const reader = new FileReader();

      reader.onload = (e) => {
        document.url = e.target.result;
      };

      reader.readAsDataURL(pdfAttachment);

      if (index < 0) attachments.push(document);
      else attachments[index] = document;

      setproviderAttachments(attachments);

      const errorIndex = errors.attachmentHasErrors.findIndex(
        (id) => id === document.id,
      );

      if (errorIndex >= 0) errors.attachmentHasErrors.splice(errorIndex, 1);

      // console.log(errorIndex);
    }
  };

  // const cpdAttachmentTypes = [
  //   { id: 1, name: "RDB/RGB registration certificate" },
  //   {
  //     id: 2,
  //     name: "Action and implementation plan on the area of intervention",
  //   },
  //   { id: 3, name: "Signed MOU" },
  // ];

  const [organizationType, setOrganizationType] = useState(null);
  const [providerPrograms, setProviderPrograms] = useState([]);

  const [requestForm, setRequestForm] = useState({
    countryId: "RW",
    tinNumber: "",
    tinVerified: "",
    institutionName: "",
    acronym: "",
    organizationTypeId: "",
    email: "",
    phone: "",
    password: "",
    passwordRetype: "",
    emailOtp: "",
    phoneOtp: "",
  });

  const [confirmed, setConfirmed] = useState(false);

  const [isPasswordStrong, setIsPasswordStrong] = useState(false);
  const [verifying, setVerifying] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [showOtpDialog, setShowOtpDialog] = useState(false);

  const [isSubmitted, setIsSubmitted] = useState(false);

  const verifyTinNumber = async () => {
    try {
      setRequestForm({
        ...requestForm,
        institutionName: "",
        acronym: "",
      });
      setVerifying(true);

      const { data } = await axios.get(
        `/api/cpd/verify-tin?tin=${requestForm.tinNumber}`,
      );

      setRequestForm({
        ...requestForm,
        tinVerified: data.verified,
        institutionName: data.institutionName || "",
        acronym: "",
      });

      setErrors({
        ...errors,
        institutionNameHasError: false,
        tinNumberHasError: false,
      });

      setVerifying(false);
    } catch (error) {
      setVerifying(false);
    }
  };

  const verifyProviderContacts = async () => {
    try {
      setSubmitting(true);

      await axios.post(`/api/cpd/verify-provider-contacts`, {
        email: (requestForm.email || "").trim(),
        phone: (requestForm.phone || "").replace(/\s/g, "").slice(-10),
      });

      setShowOtpDialog(true);

      setSubmitting(false);
    } catch (error) {
      setSubmitting(false);
      showError(error);
    }
  };

  const onSubmit = async () => {
    try {
      const tmpProviderPrograms = [];
      providerPrograms.forEach(({ id }) => tmpProviderPrograms.push(id));

      requestForm.email = (requestForm.email || "").trim();
      requestForm.phone = (requestForm.phone || "")
        .replace(/\s/g, "")
        .slice(-10);

      const formData = new FormData();
      const keys = Object.keys(requestForm);

      for (const key of keys) {
        if (requestForm.hasOwnProperty(key)) {
          formData.append(`${key}`, `${requestForm[key]}`);
        }
      }

      formData.append(`providerPrograms`, tmpProviderPrograms);
      formData.append(
        `providerAttachments`,
        JSON.stringify(providerAttachments.map((att) => att.id)),
      );

      providerAttachments.forEach((row, i) => {
        formData.append("files", row.file);
      });

      setSubmitting(true);

      await axios.post(`/api/cpd/membership-requests`, formData);

      setSubmitting(false);
      setIsSubmitted(true);
      showSuccess("Submitted successfully");
    } catch (error) {
      setSubmitting(false);
      showError(error);
    }
  };

  const [errors, setErrors] = useState({
    tinNumberHasError: false,
    institutionNameHasError: false,
    organizationTypeIdHasError: false,
    providerProgramsHasError: false,
    emailHasError: false,
    phoneHasError: false,
    passwordHasError: false,
    passwordRetypeHasError: false,
    emailOtpHasError: false,
    phoneOtpHasError: false,
    attachmentHasErrors: [],
    hasError: false,
  });

  const formErrors = () => {
    const error = {
      tinNumberHasError: false,
      institutionNameHasError: false,
      organizationTypeIdHasError: false,
      providerProgramsHasError: false,
      emailHasError: false,
      phoneHasError: false,
      passwordHasError: false,
      passwordRetypeHasError: false,
      emailOtpHasError: false,
      phoneOtpHasError: false,
      attachmentHasErrors: [],
      hasError: false,
    };

    if (!requestForm.tinNumber || !requestForm.tinVerified) {
      error.tinNumberHasError = true;
      error.hasError = true;
    }

    if (!requestForm.institutionName) {
      error.institutionNameHasError = true;
      error.hasError = true;
    }

    if (!requestForm.organizationTypeId) {
      error.organizationTypeIdHasError = true;
      error.hasError = true;
    }

    if (!providerPrograms.length) {
      error.providerProgramsHasError = true;
      error.hasError = true;
    }

    if (!requestForm.phone) {
      error.phoneHasError = true;
      error.hasError = true;
    }

    if (!requestForm.email) {
      error.emailHasError = true;
      error.hasError = true;
    }

    if (!requestForm.password || !isPasswordStrong) {
      error.passwordHasError = true;
      error.hasError = true;
    }

    if (
      !requestForm.passwordRetype ||
      (!!requestForm.passwordRetype &&
        requestForm.passwordRetype !== requestForm.password)
    ) {
      error.passwordRetypeHasError = true;
      error.hasError = true;
    }

    cpdAttachmentTypes.forEach((doc) => {
      const document = providerAttachments.find(({ id }) => doc.id === id);

      if (!document && !!doc.isRequired) {
        error.attachmentHasErrors.push(doc.id);
      }
    });

    setErrors(error);

    if (error.hasError || error.attachmentHasErrors.length) {
      return true;
    }
    return false;
  };

  useEffect(() => {
    if (!showOtpDialog) setConfirmed(false);
  }, [requestForm, providerPrograms, providerAttachments]);

  const [showApplicationTrackerDialog, setShowApplicationTrackerDialog] =
    useState(false);

  const history = useHistory();

  return (
    <>
      <div className="container py-5">
        <div className="row justify-content-center pb-5">
          <div className="col-12 col-lg-8 row border rounded bg-white p-3">
            <div className="col-12 ">
              <IconButton
                className="float-right  "
                aria-label="close"
                onClick={() => history.push("/")}
                // sx={{
                //   position: "absolute",
                //   right: 8,
                //   top: 8,
                //   color: (theme) => theme.palette.grey[500],
                // }}
              >
                <span className="material-icons">close</span>
              </IconButton>
              <div
                className="text-center mb-3 py-2 border-bottom "
                // style={{
                //   backgroundColor: "#e0e0e0",
                // }}
              >
                <Button
                  variant="contained"
                  size="small"
                  startIcon={<SearchIcon style={{ fontSize: "18px" }} />}
                  style={{
                    cursor: "pointer",
                    color: "white",
                    padding: "0.4rem 2rem",
                    borderRadius: "50px",
                    transition: "all 0.3s",
                  }}
                  onClick={() => setShowApplicationTrackerDialog(true)}
                >
                  TRACK YOUR APPLICATION
                </Button>
              </div>
              <h1
                className="h4 fw-bold text-center text-uppercase"
                style={{ color: "#001d40" }}
              >
                Training Provider Membership Application Form
              </h1>

              {/* <di4
              className="d-flex align-items-center gap-2 btn rounded-pill px-4 py-2 mb-3 shadow"
              style={{
                cursor: "pointer",
                background: "linear-gradient(to right, #e76f51, #fd7e14)",
                color: "white",
                padding: "0.75rem 2rem",
                borderRadius: "50px",
                fontWeight: 600,
                fontSize: "1.1rem",
                boxShadow: "0 8px 32px rgba(253,126,20,0.12)",
                transition: "all 0.3s",
              }}
              onClick={() => {}}
            >
              <SearchIcon style={{ fontSize: "18px" }} />
              <span className="fw-medium"> TRACK YOUR APPLICATION</span>
            </div> */}
            </div>

            {!isSubmitted ? (
              <>
                <div className="col-4 text-left mt-2">
                  <FormControl
                    required
                    fullWidth
                    error={errors.organizationTypeIdHasError}
                  >
                    <InputLabel id="countryId">Country</InputLabel>
                    <Select
                      style={{
                        backgroundColor: "#e9ecef",
                      }}
                      readOnly={true}
                      labelId="countryId"
                      id="countryId"
                      value={requestForm.countryId}
                      label="Country"
                      onChange={(event) => {
                        setRequestForm({
                          ...requestForm,
                          countryId: event.target.value,
                        });
                      }}
                    >
                      {[{ id: "RW", name: "Rwanda" }].map((item) => (
                        <MenuItem key={item.id} value={item.id}>
                          {item.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
                <div className="col-8 text-left mt-2 ">
                  <FormControl
                    // required
                    fullWidth
                    variant="outlined"
                    sx={{ mb: 1 }}
                    error={
                      requestForm.tinVerified === false ||
                      errors.tinNumberHasError
                    }
                  >
                    <InputLabel
                      htmlFor="tinNumber"
                      className="d-inline-flex align-items-center"
                    >
                      TIN Number
                      {requestForm.tinVerified !== "" && (
                        <span
                          className={`ml-1 badge badge-${
                            requestForm.tinVerified === true
                              ? "success"
                              : "danger"
                          } `}
                        >
                          {requestForm.tinVerified === true ? (
                            <>
                              <TaskAltIcon style={{ fontSize: "14px" }} />{" "}
                              Verified
                            </>
                          ) : (
                            <>
                              <ReportProblemIcon style={{ fontSize: "14px" }} />{" "}
                              Error
                            </>
                          )}
                        </span>
                      )}
                    </InputLabel>
                    <OutlinedInput
                      readOnly={showOtpDialog}
                      id="tinNumber"
                      placeholder="TIN Number"
                      name="tinNumber"
                      type="text"
                      value={requestForm.tinNumber || ""}
                      onChange={(e) => {
                        setRequestForm({
                          ...requestForm,
                          tinNumber: e.target.value || "",
                          tinVerified: "",
                          institutionName: "",
                          acronym: "",
                        });

                        setErrors({ ...errors, tinNumberHasError: false });
                      }}
                      endAdornment={
                        <InputAdornment position="end">
                          <Button
                            type="button"
                            disabled={
                              !requestForm?.tinNumber ||
                              verifying ||
                              showOtpDialog
                            }
                            startIcon={
                              <LoopIcon
                                className={`${verifying ? "spinner" : ""} `}
                              />
                            }
                            color="primary"
                            size="large"
                            fullWidth
                            variant="contained"
                            onClick={() => verifyTinNumber()}
                          >
                            Verify
                          </Button>
                        </InputAdornment>
                      }
                      label="TIN Number"
                    />
                  </FormControl>
                </div>
                <div className="col-12 text-left mt-2">
                  <TextField
                    required
                    style={{ backgroundColor: "#e9ecef" }}
                    InputProps={{
                      readOnly: true,
                    }}
                    fullWidth
                    name="institutionName"
                    label="Institution Name"
                    placeholder="Institution Name"
                    variant="outlined"
                    value={requestForm.institutionName || ""}
                    error={errors.institutionNameHasError}
                  />
                </div>
                <div className="col-12 text-left mt-3">
                  <TextField
                    type="text"
                    fullWidth
                    name="acronym"
                    label="Acronym"
                    placeholder="Acronym"
                    variant="outlined"
                    value={requestForm.acronym}
                    onChange={(event) => {
                      setRequestForm({
                        ...requestForm,
                        acronym: event.target.value,
                      });
                    }}
                    InputProps={{
                      readOnly: showOtpDialog,
                    }}
                  />
                </div>

                <div className="col-12 text-left mt-3">
                  <FormControl
                    required
                    fullWidth
                    error={errors.organizationTypeIdHasError}
                  >
                    <InputLabel id="organizationType">
                      Organization type
                    </InputLabel>
                    <Select
                      readOnly={showOtpDialog}
                      labelId="organizationType"
                      id="organizationTypeSelect"
                      value={requestForm.organizationTypeId}
                      label="Organization type"
                      onChange={(event) => {
                        setRequestForm({
                          ...requestForm,
                          organizationTypeId: event.target.value,
                        });

                        setErrors({
                          ...errors,
                          organizationTypeIdHasError: false,
                        });
                      }}
                    >
                      {organizationTypes
                        .filter(({ isActive }) => !!isActive)
                        ?.map((item) => (
                          <MenuItem key={item.id} value={item.id}>
                            {item.name}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </div>
                <div className="col-12 text-left mt-3">
                  <Autocomplete
                    readOnly={showOtpDialog}
                    fullWidth
                    multiple
                    id="providerPrograms"
                    name="providerPrograms"
                    options={
                      programs.filter(({ isActive }) => !!isActive) || []
                    }
                    value={providerPrograms}
                    // disableCloseOnSelect
                    getOptionLabel={(option) => option.name}
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    renderOption={(props, option, { selected }) => {
                      const { key, ...optionProps } = props;
                      return (
                        <li key={key} {...optionProps}>
                          <Checkbox
                            icon={icon}
                            checkedIcon={checkedIcon}
                            style={{ marginRight: 8 }}
                            checked={selected}
                          />
                          {option.name}
                        </li>
                      );
                    }}
                    renderInput={(params) => (
                      <TextField
                        error={errors.providerProgramsHasError}
                        required
                        {...params}
                        label="Areas of intervention"
                        placeholder="Select areas of intervention"
                        inputProps={{
                          ...params.inputProps,
                          autoComplete: "providerPrograms", // disable autocomplete and autofill
                        }}
                      />
                    )}
                    onChange={(event, program) => {
                      setProviderPrograms(program || []);

                      setErrors({ ...errors, providerProgramsHasError: false });
                    }}
                  />
                </div>
                <div className="col-12 text-left mt-3">
                  <TextField
                    error={errors.phoneHasError}
                    required
                    type="text"
                    fullWidth
                    name="phone"
                    label="Phone"
                    placeholder="07XXXXXXXX"
                    variant="outlined"
                    value={requestForm.phone}
                    onChange={(event) => {
                      setRequestForm({
                        ...requestForm,
                        phone: event.target.value,
                      });

                      setErrors({ ...errors, phoneHasError: false });
                    }}
                    InputProps={{
                      autoComplete: "phone",
                      readOnly: showOtpDialog,
                    }}
                  />
                </div>
                <div className="col-12 text-left mt-3">
                  <TextField
                    error={errors.emailHasError}
                    required
                    type="email"
                    fullWidth
                    name="email"
                    label="Email"
                    placeholder="Email"
                    variant="outlined"
                    value={requestForm.email}
                    onChange={(event) => {
                      setRequestForm({
                        ...requestForm,
                        email: event.target.value,
                      });

                      setErrors({ ...errors, emailHasError: false });
                    }}
                    InputProps={{
                      autoComplete: "email",
                      readOnly: showOtpDialog,
                    }}
                  />
                </div>

                <div className="col-12 text-left mt-3">
                  <TextField
                    error={
                      errors.passwordHasError ||
                      (!!requestForm.password && !isPasswordStrong)
                    }
                    required
                    type="password"
                    fullWidth
                    name="password"
                    label="Password"
                    placeholder="Password"
                    variant="outlined"
                    value={requestForm.password}
                    onChange={(event) => {
                      setRequestForm({
                        ...requestForm,
                        password: event.target.value,
                      });

                      setErrors({ ...errors, passwordHasError: false });
                    }}
                    InputProps={{
                      readOnly: showOtpDialog,
                    }}
                  />
                  {!!requestForm.password && (
                    <PasswordStrengthBar
                      className="text-uppercase font-weight-bold"
                      password={requestForm.password}
                      onChangeScore={(score, feedback) => {
                        setIsPasswordStrong(
                          !!requestForm.password && score >= 4 ? true : false,
                        );
                      }}
                    />
                  )}
                </div>
                <div
                  className={`col-12 text-left ${
                    !requestForm.password ? "mt-3" : ""
                  } `}
                >
                  <TextField
                    error={
                      errors.passwordRetypeHasError ||
                      (!!requestForm.passwordRetype &&
                        requestForm.passwordRetype !== requestForm.password)
                    }
                    required
                    type="password"
                    fullWidth
                    name="passwordRetype"
                    label="Retype password"
                    placeholder="Retype password"
                    variant="outlined"
                    value={requestForm.passwordRetype}
                    onChange={(event) => {
                      setRequestForm({
                        ...requestForm,
                        passwordRetype: event.target.value,
                      });

                      setErrors({ ...errors, passwordRetypeHasError: false });
                    }}
                    InputProps={{
                      readOnly: showOtpDialog,
                    }}
                  />

                  <Alert severity="info" className="mt-1">
                    Please note that the above <strong>email</strong> and{" "}
                    <strong>password</strong> will be used as your login
                    credential for accessing the system.
                  </Alert>
                </div>

                <div
                  className="col-12 mt-3"
                  // style={{ backgroundColor: "#ccefff75" }}
                >
                  <fieldset
                    className={`row mx-0 p-3 rounded border ${
                      errors.attachmentHasErrors.length ? "border-danger" : ""
                    }`}
                  >
                    <legend
                      className={`col-12 w-auto px-2 text-primary`}
                      style={{
                        fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
                        fontWeight: 400,
                        fontSize: "0.82rem",
                        lineHeight: "1em",
                        letterSpacing: "0.00938em",
                      }}
                    >
                      Required documents
                    </legend>

                    {cpdAttachmentTypes.map((document, index) => (
                      <DocumentItem
                        error={errors.attachmentHasErrors.find(
                          (err) => err === index + 1,
                        )}
                        disabled={showOtpDialog}
                        key={document.id}
                        document={document}
                        providerAttachments={providerAttachments}
                        setproviderAttachments={setproviderAttachments}
                        setShowUploadedDocument={setShowUploadedDocument}
                        setUploadedDocument={setUploadedDocument}
                        handleUploadedPDFFile={handleUploadedPDFFile}
                        // getDocumentDescription={getDocumentDescription}
                      />
                    ))}
                  </fieldset>
                </div>

                <div className="col-12 text-center">
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={confirmed}
                        onChange={(e) => {
                          if (!showOtpDialog && !formErrors())
                            setConfirmed(e.target.checked);
                        }}
                      />
                    }
                    label="I certify that the above information is true and accurate."
                  />
                </div>

                {!!showOtpDialog && (
                  <div className="col-12">
                    <Card className="rounded border bg-light border-primary p-2">
                      <CardContent>
                        <Alert
                          className="text-center border border-primary"
                          icon={false}
                          severity="info"
                          sx={{
                            borderRadius: "8px",
                            "& .MuiAlert-message": {
                              width: "100%",
                            },
                          }}
                        >
                          <AlertTitle sx={{ fontWeight: 600 }}>
                            Phone and Email verfication
                          </AlertTitle>
                          <Typography variant="body2">
                            Please check the verification codes sent to your
                            phone and email.
                          </Typography>
                        </Alert>
                        <Box component="form" sx={{ mt: 1 }}>
                          <TextField
                            className="mt-2"
                            type="number"
                            fullWidth
                            name="emailVerificationCode"
                            label="Email Verification Code"
                            placeholder="Email Verification Code"
                            variant="outlined"
                            value={requestForm.emailOtp}
                            onChange={(event) => {
                              setRequestForm({
                                ...requestForm,
                                emailOtp: event.target.value,
                              });
                            }}
                          />
                          <TextField
                            className="mt-3"
                            type="number"
                            fullWidth
                            name="phoneVerificationCode"
                            label="Phone Verification Code"
                            placeholder="Phone Verification Code"
                            variant="outlined"
                            value={requestForm.phoneOtp}
                            onChange={(event) => {
                              setRequestForm({
                                ...requestForm,
                                phoneOtp: event.target.value,
                              });
                            }}
                          />
                          <div className="text-right">
                            <Button
                              variant="text"
                              type="button"
                              onClick={() => {
                                verifyProviderContacts();
                              }}
                            >
                              Resend code
                            </Button>
                          </div>
                        </Box>
                      </CardContent>
                    </Card>
                  </div>
                )}
                {(!!errors.tinNumberHasError ||
                  !!errors.institutionNameHasError ||
                  !!errors.organizationTypeIdHasError ||
                  !!errors.providerProgramsHasError ||
                  !!errors.emailHasError ||
                  !!errors.phoneHasError ||
                  !!errors.passwordHasError ||
                  !!errors.passwordRetypeHasError ||
                  !!errors.emailOtpHasError ||
                  !!errors.phoneOtpHasError ||
                  !!errors.attachmentHasErrors.length) && (
                  <div className="col-12 mt-1">
                    <Alert
                      className="text-center border border-danger"
                      // icon={false}
                      severity="error"
                      sx={{
                        borderRadius: "8px",
                        "& .MuiAlert-message": {
                          width: "100%",
                        },
                      }}
                    >
                      Please complete all the required fields above.
                    </Alert>
                  </div>
                )}
                <div className="col-12 mt-3">
                  <Button
                    disabled={
                      !confirmed ||
                      submitting ||
                      (showOtpDialog &&
                        (!(requestForm.emailOtp || "") ||
                          !(requestForm.phoneOtp || "")))
                    }
                    onClick={() => {
                      if (showOtpDialog) onSubmit();
                      else verifyProviderContacts();
                    }}
                    size="large"
                    fullWidth
                    variant="contained"
                    color={showOtpDialog ? "success" : "primary"}
                    type="button"
                  >
                    {showOtpDialog ? "Submit" : "Next"}
                  </Button>
                </div>
              </>
            ) : (
              <>
                <Alert
                  className="text-center mb-4 border border-success py-5"
                  icon={false}
                  severity="success"
                  sx={{
                    borderRadius: "8px",
                    "& .MuiAlert-message": {
                      width: "100%",
                    },
                  }}
                >
                  <AlertTitle sx={{ fontWeight: 600 }}>
                    Your application was submitted successfully
                  </AlertTitle>
                  <Typography variant="body2">
                    We will notify you once it is approved.
                  </Typography>

                  <Link
                    style={{
                      textDecoration: "none",
                    }}
                    to="/"
                    className="d-inline-flex mt-3 btn btn-link text-uppercase"
                  >
                    <span className="material-icons">
                      keyboard_double_arrow_left
                    </span>
                    Go back
                  </Link>
                </Alert>
              </>
            )}
          </div>
        </div>
      </div>

      {showApplicationTrackerDialog && (
        <ApplicationTrackerDialog
          showLoginDialog={showApplicationTrackerDialog}
          setShowLoginDialog={setShowApplicationTrackerDialog}
        />
      )}
    </>
  );
};

const ApplicationTrackerDialog = (props) => {
  const { showLoginDialog, setShowLoginDialog } = props;

  const [application, setApplication] = useState(null);
  const [applicationNumber, setApplicationNumber] = useState("");

  const [loading, setLoading] = useState(false);

  const trackApplication = async () => {
    try {
      setLoading(true);
      setApplication(null);
      const { data } = await axios.get(
        `/api/cpd/membership-requests/${applicationNumber}`,
      );
      setLoading(false);

      setApplication(data);
    } catch (error) {
      setLoading(false);
      showError(error);
    }
  };

  return (
    <Dialog
      maxWidth="xs"
      fullWidth
      onClose={() => {
        setShowLoginDialog(false);
      }}
      open={showLoginDialog}
      PaperProps={{
        sx: {
          borderRadius: "16px",
          boxShadow: "0 10px 40px rgba(0,0,0,0.1)",
          overflow: "hidden",
        },
      }}
    >
      <DialogTitle
        sx={{
          background: "white",
          padding: "24px",
          position: "relative",
        }}
      >
        <Typography variant="h5" component="h2">
          Track your application
        </Typography>
        <IconButton
          aria-label="close"
          onClick={() => {
            setShowLoginDialog(false);
          }}
          sx={{
            position: "absolute",
            right: 16,
            top: 16,
            color: "rgba(0,0,0,0.5)",
            "&:hover": {
              color: "rgba(0,0,0,0.7)",
              background: "rgba(0,0,0,0.04)",
            },
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ minHeight: "200px" }}>
        <Box>
          <div className="row align-items-center justify-content-between mt-2">
            <div className="col-9  text-left">
              <TextField
                autoFocus
                fullWidth
                size="small"
                name="applicationNumber"
                label="TIN Number"
                placeholder="TIN Number"
                variant="outlined"
                className=" font-weight-bold"
                value={applicationNumber}
                onChange={(e) => {
                  setApplicationNumber(e.target.value || "");
                }}
              />
            </div>
            <div className="col-3 text-right">
              <Button
                variant="contained"
                disabled={loading || !applicationNumber}
                onClick={trackApplication}
              >
                <span className="material-icons">search</span>
              </Button>
            </div>
          </div>

          {!!application && (
            <Alert
              icon={
                application.statusId === 1 ? (
                  <span className="material-icons">pending</span>
                ) : application.statusId === 2 ? (
                  <span className="material-icons">check_circle_outline</span>
                ) : (
                  <span className="material-icons">cancel</span>
                )
              }
              severity={`${application.statusId === 1 ? "info" : application.statusId === 2 ? "success" : "error"}`}
              className="mt-3"
              sx={{
                mb: 3,
                borderRadius: "8px",
                "& .MuiAlert-message": {
                  width: "100%",
                },
              }}
            >
              <Typography variant="body2">
                Your application is <strong>{application.statusName}</strong>
              </Typography>

              {!!application.statusComment && application.statusId !== 1 && (
                <p className="mt-2 border p-2 bg-light">
                  {application.statusComment}
                </p>
              )}
            </Alert>
          )}
        </Box>
      </DialogContent>
    </Dialog>
  );
};
